import React from 'react';
import { STYLED_BUTTON_TYPE, StyledButton } from 'taboola-ultimate-ui';
import { ENTITY } from '../../../../modules/campaigns/config';
import { useOpenCampaignEditor } from '../../../../modules/campaigns/hooks';
import useOpenCampaignsGroupEditor from '../../../../modules/campaigns/modules/campaigns-group/hooks/useOpenCampaignsGroupEditor';
import styles from './DropdownCampaignEditButton.module.scss';

const DropdownCampaignEditButton = ({ entity, data }) => {
    const onEditCampaign = useOpenCampaignEditor();
    const onEditCampaignGroup = useOpenCampaignsGroupEditor();

    const handleEditClick = e => {
        e.preventDefault();
        e.stopPropagation();

        if (entity === ENTITY.CAMPAIGN) {
            onEditCampaign(data);
        }
        if (entity === ENTITY.CAMPAIGNS_GROUP) {
            onEditCampaignGroup({ ...data, campaignsGroupId: data.id });
        }
    };
    return (
        <StyledButton
            aria-label="Edit campaign"
            className={styles['edit-button']}
            iconBefore="edit-o"
            iconBeforeClassName={styles['edit-icon']}
            onClick={handleEditClick}
            type={STYLED_BUTTON_TYPE.BORDERLESS_ICON}
        />
    );
};

export default DropdownCampaignEditButton;
